<template>
    <Tooltip :text="tooltip" position="left">
        <div class="cursor-pointer" :class="{'text-green-500 hover:text-green-700': props.activated, 'text-red-500 hover:text-red-700': !props.activated}">
            <svg v-if="props.activated" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 ">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
        </div>
    </Tooltip>
</template>
<script setup>
import { defineProps } from 'vue';
const props = defineProps({
    activated: {
        type: Boolean,
    },
    tooltip: {
        type: String
    }
});
</script>